import { FC } from 'react'

import { FooterContainer, FooterWrapper } from './styles'

const Footer: FC = () => (
  <FooterWrapper>
    <FooterContainer>
      <span>
        &copy; {new Date().getFullYear()} STRETTO. All Rights Reserved.
      </span>
      <ul
        style={{
          listStyleType: 'none',
          display: 'flex',
          gap: '10px'
        }}
      >
        <li>
          <a
            href='https://www.stretto.com/legal-policies/'
            target='_blank'
            rel='noreferrer'
          >
            Terms and Conditions
          </a>
        </li>
        <li>|</li>
        <li>
          <a
            href='https://www.stretto.com/privacy/'
            target='_blank'
            rel='noreferrer'
          >
            Privacy Policy
          </a>
        </li>
        <li>|</li>
        <li>
          <a
            className='ot-sdk-show-settings'
            href='#'
            role='button'
            aria-controls='onetrust-pc-sdk'
          >
            Cookie settings
          </a>
        </li>
      </ul>
    </FooterContainer>
  </FooterWrapper>
)

export default Footer
